import Yt from "./filter-set.js";
export default class is {
  constructor(t, s) {
    (this.productId = t), (this.Jl = s), (this.productId = t), (this.Jl = s);
  }
  Bl(t) {
    if (null == this.productId || null == this.Jl) return !1;
    const s = t[0],
      i = t[1];
    return s === this.productId && this.Jl.Bl(i);
  }
  static fromJson(t) {
    return new is(
      t ? t.product_id : null,
      t ? Yt.fromJson(t.property_filters) : null,
    );
  }
  ss() {
    return { id: this.productId, pf: this.Jl ? this.Jl.ss() : null };
  }
}
